import Box from '@mui/material/Box';
import Ty from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

function NotFoundDemo() {
  const { t } = useTranslation();
  return (
    <Box
      display='flex'
      justifyContent='flexStart'
      paddingTop='100px'
      alignItems='center'
      height='100%'
      maxWidth='68ch'
      margin='auto'
      flexDirection='column'
      data-testid='404'
    >
      <Ty variant='h4' sx={{ marginBottom: '24px' }}>
        {t('global.pageNotFound')}
      </Ty>
    </Box>
  );
}

export default NotFoundDemo;
